<div class="container-fluid bg-primary">
  <div class="container">
    <p>Copyright 2026 &copy; Azzulei Technologies - v.{{ VERSION_NAME }}</p>
  </div>
</div>
